
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{staticClass:"fill-current",class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 2369.45 2369.45","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M433.45 0H1936c119.42 0 227.78 48.84 306 127.06 78.6 78.6 127.44 187 127.44 306.39V1936c0 119.42-48.84 227.78-127.44 306-78.6 78.6-187 127.44-306 127.44H433.45c-119.43 0-227.79-48.84-306.39-127.44C48.84 2163.79 0 2055.43 0 1936V433.45c0-119 48.84-227.41 127.06-306v-.38C205.66 48.84 314 0 433.45 0zM1936 185.05H433.45a247.79 247.79 0 00-175.52 72.88 247.79 247.79 0 00-72.88 175.52V1936a248.83 248.83 0 00248.4 248.39H1936a247.78 247.78 0 00175.51-72.88A247.78 247.78 0 002184.4 1936V433.45a248.83 248.83 0 00-248.4-248.4zM659.71 739.83A92.82 92.82 0 01567 647.12c0-50.75 41.59-92.34 92.72-92.34h1050c51.13 0 92.72 41.59 92.72 92.34a92.82 92.82 0 01-92.72 92.71zm0 537.23c-51.13 0-92.72-41.21-92.72-92.33s41.59-92.34 92.72-92.34h525a92.34 92.34 0 010 184.67zm0 537.61A92.82 92.82 0 01567 1722c0-50.74 41.59-92.33 92.72-92.33h1050c51.13 0 92.72 41.59 92.72 92.33a92.82 92.82 0 01-92.72 92.72z","fill-rule":"evenodd"}})])
      }
    
      }
    


//////////////////
// WEBPACK FOOTER
// ./images/icons/icon-details.svg
// module id = 406
// module chunks = 0